import React, { useState } from 'react';

const Cart = ({ history }) => {
  const [cart, setCart] = useState([]);
  const [total, setTotal] = useState(0);

  const addToCart = (img, price) => {
    setCart([...cart, { img, price }]);
    setTotal(total + parseFloat(price));
  };

  return (
    <div className="row">
      <div className="col-12 text-center">
        <h1>Cart</h1>
        <div className="row">
          {history.map((img, index) => (
            <div key={index} className="col-6 col-md-4 col-lg-3 mb-4">
              <img src={img} alt={`dog-${index}`} className="img-fluid" />
              <input
                type="number"
                placeholder="Enter price"
                onBlur={(e) => addToCart(img, e.target.value)}
                className="form-control mt-2"
              />
            </div>
          ))}
        </div>
        <h2>Total: ${total.toFixed(2)}</h2>
      </div>
    </div>
  );
};

export default Cart;
